// extracted by mini-css-extract-plugin
export var active = "_da-7";
export var blink = "_da-8";
export var dropDownSelector = "_da-4";
export var dropDownWrapper = "_da-3";
export var fakeCursor = "_da-6";
export var fontSizeButton = "_da-9";
export var formQuillEditor = "_da-0";
export var pressed = "_da-a";
export var qlBlank = "_da-1";
export var textFormattingToolbar = "_da-2";
export var textToolbarOption = "_da-5";